import {Pipe, PipeTransform} from '@angular/core';
import {ChecklistQuestionGroupType} from "@services";

@Pipe({
    name: 'checklistQuestionGroupType',
    standalone: true
})
export class ChecklistQuestionGroupTypePipe implements PipeTransform {
    transform(value: ChecklistQuestionGroupType | string | undefined | null): string {
        if (!value) return 'Questions';

        switch (value) {
            case ChecklistQuestionGroupType.AfterStartingMachine: return 'After Starting Machine';
            case ChecklistQuestionGroupType.BeforeStartingMachine: return 'Before Starting Machine';
            case ChecklistQuestionGroupType.AfterStartingMachineCounterBalance: return 'After Starting Machine';
            case ChecklistQuestionGroupType.BeforeStartingMachineCounterBalance: return 'Before Starting Machine';
            case ChecklistQuestionGroupType.MobileLabelPrinter: return 'Mobile Label Printer';
            case ChecklistQuestionGroupType.RadioShuttleCart: return 'Radio Shuttle Cart';
            case ChecklistQuestionGroupType.RadioShuttleRemote: return 'Radio Shuttle Remote';
            case ChecklistQuestionGroupType.RfScanningGun: return 'RF Scanning Gun';
            case ChecklistQuestionGroupType.TabletComputers: return 'Tablet Computers';
            case ChecklistQuestionGroupType.TwoWayRadio: return '2 Way Radio';
            case ChecklistQuestionGroupType.SlipSheetAttach: return 'Slip Sheet Attach';
            case ChecklistQuestionGroupType.ClampLayerAttach: return 'Clamp Layer Attach';
            case ChecklistQuestionGroupType.HandheldScanner: return 'Handheld RF Terminal Scanner';
            case ChecklistQuestionGroupType.Scrubbers: return 'Scrubbers';
            case ChecklistQuestionGroupType.ShuntTruck: return 'Shunt Truck';
            case ChecklistQuestionGroupType.ScissorLiftVisualInspection: return 'Scissor Lift - Visual Inspection';
            case ChecklistQuestionGroupType.ScissorLiftOperationalInspection: return 'Scissor Lift - Operational Inspection';
            case ChecklistQuestionGroupType.ScissorLiftBatteryPowered: return 'Scissor Lift - Battery Powered';
            case ChecklistQuestionGroupType.WrapMachine: return 'Wrap Machine';
            default: return 'Questions';
        }
    }
}

